export default __webpack_public_path__ + "static/test-ng-cb74f13495a98854e989b4499e574df3.svg";